<template>
  <main>
    <section id="section__primary">
      <article>
        <h2 v-if="listingCategory === 'active'">Active Listings</h2>
        <h2 v-if="listingCategory === 'sold'">Current Show Home </h2>
        <p v-if="listingCategory === 'active'">Whether you're looking to purchase your first home, "stepping up a level", or acquiring your "dream home", Stewart can make it happen. Here are his current listings of homes on the market...</p>
        <p v-if="listingCategory === 'sold'">&nbsp;</p>
      </article>
      <ListingRack
        prp_classes="card_view"
        :prp_ofCategory="listingCategory"
      />
    </section>
  </main>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import ListingRack from './Listing__Rack.vue';
import { useRoute } from 'vue-router';

const listingCategory = ref('');
const route = useRoute();

const setListingCategory = () => {
  if (route.path === '/homes-ive-sold') {
    listingCategory.value = 'sold';
  }
  if (route.path === '/active-listings') {
    listingCategory.value = 'active';
  }
};

// Watch for route changes to update listing category
watch(route, (to) => {
  if (to.path === '/homes-ive-sold') {
    listingCategory.value = 'sold';
  }
  if (to.path === '/active-listings') {
    listingCategory.value = 'active';
  }
});

// Component mounted - set initial category
onMounted(() => {
  setListingCategory();
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '@/scss/_global.scss';

  section#section__primary {
    background: $color__background--light;
    color: 666;
  }

</style>
